import { Layout, Menu, Divider, Avatar, Popover } from "antd";
import styled from "styled-components";
import { withRouter } from "react-router";
import React, { Component } from "react";
import { path } from "ramda";
import I18n from "../../i18n";
import SiderRoute from "../../constants/siderRoute";
import SettingActions from "../../reducers/SettingReducer";
import store, { ReducerKeys } from "../../reducers/";
import { withThemeProvider } from "../../hoc";
import { ContentMenu, MenuType } from "./Menu";
import { clearStore } from "../../actions/StoreAction";
import { isAlive } from "../../util";
import OrgUtil from "../../util/organize";
import RouteUtil from "../../util/route";
import { Metrics, Colors } from "../../theme";
import UserUtil from "../../util/user";

const { Header, Content, Sider } = Layout;

const checkClick = (value) => {
	switch (value.key) {
	case "1":
		clearStore();
		break;
	default:
		return "no key detect";
	}
};

class MainLayout extends Component {
    state = {
    	collapsed: store.getState().setting.siderStatus,
    };
    texts = {}
    siderProps = {
    	routes: {},
    	paths: {}
    }
    constructor(props) {
    	super(props);
    	const storeState = store.getState();
    	this.state = {
    		collapsed: storeState.setting.siderStatus,
    	};
    	this.buildRoutes();
    }
    componentWillReceiveProps(props) {
    	this.buildRoutes();
    }
    buildRoutes() {
    	this.siderProps.paths = RouteUtil.CreateSiderPaths();
    	this.siderProps.routes = RouteUtil.CreateSiderRoutes();
    }
    onCollapse = (collapsed) => {
    	this.setState({ collapsed }, () => store.dispatch(SettingActions.setSiderStatus(collapsed)));
    }
    toSiderPath(routePath) {
    	const siderPathKey = routePath.startsWith("/") ? routePath.split("/")[1] : routePath;
    	if (this.siderProps.paths[siderPathKey] !== undefined) {
    		return this.siderProps.paths[siderPathKey].split("/").filter(f => f !== "");
    	}
    	return routePath;
    }
    render() {
    	const { routes, paths } = this.siderProps;
    	const { mainColor } = this.props.theme;
    	const { id, children, history, location: { pathname } } = this.props;
    	const defaultOpenKeys = this.toSiderPath(pathname);
    	const defaultSelectedKeys = defaultOpenKeys[Math.max(0, defaultOpenKeys.length - 1)];
    	//console.log("layout: ",{pathname, defaultOpenKeys, defaultSelectedKeys});
    	const { name = "OrgName", images } = path([ReducerKeys.ORGANIZATION, "organization"], store.getState()) || {};
    	const banner = path(["banner"], images);
    		routes.unshift({
    			icon: { type: "bars" },
    			key: "corporatelist",
    			text: "Back To Corporate List"
    		});
    	return (
    		<Layout style={{ minHeight: "100vh" }}>
    			<Sider
    				collapsible
    				collapsed={this.state.collapsed}
    				onCollapse={this.onCollapse}
    				style={{
    					background: "#32323a",
    					boxShadow: "4px 5px 4px 0 rgba(0, 0, 0, 0.05)",
    				}}
    				width={238} >
    				<Header style={{ background: mainColor, padding: 0, textAlign: "center", color: "white" }}>
    					{isAlive(banner) ?
    						<img style={{ objectFit: "contain", maxWidth: 45, maxHeight: 45 }}
    							alt={name} src={banner} /> : <p>{name}</p>}
    				</Header>
    				<ContentMenu
    					theme={this.props.theme}
    					menuItemProps={routes}
    					roleUser= {store.getState()[ReducerKeys.USER].user.roles}
    					MenuContainer={{
    						defaultSelectedKeys: [defaultSelectedKeys],
    						defaultOpenKeys: this.state.collapsed ? [] : defaultOpenKeys,
    						onClick: ({ item, key, keyPath }) => {
    							history.replace(`/${key}`);
    						},
    					}}
    				/>
    			</Sider>
    			<Layout style={{ background: "#fff" }}>
    				<Header style={{ background: "#fff", padding: "0 16px 0 16px" }}>
    					<Popover placement="bottom" content={
    						<Menu
    							mode="horizontal"
    							onClick={value => checkClick(value)}
    						>
    							<Menu.Item key="1" >
    								<span>Log Out</span>
    							</Menu.Item>
    						</Menu>
    					} trigger="click">
    						<div style={{ float: "right", cursor: "pointer" }}>
    							<Avatar size="large" icon="user"
    								style={{ margin: "0 10px 0 10px", verticalAlign: "middle" }} />
    							{store.getState()[ReducerKeys.USER].user.email}
    						</div>
    					</Popover>
    					<Divider style={{ margin: 0, top: "64px" }} type="horizontal" />

    				</Header>
    				<Content id={id} style={{ padding: "0 16px", height: "calc(100vh - 64px)", overflowY: "scroll", overflowX: "hidden" }}>
    					{
    						children
    					}
    				</Content>
    				{/* <Footer style={{ textAlign: 'center' }}>
                        Ant Design ©2016 Created by Ant UED
                    </Footer> */}
    			</Layout>
    		</Layout>
    	);
    }
}
export const HoverableDiv = styled.div`
	${props=>props.pointer ? "cursor:pointer;" : ""}
	&:hover {
		background-color:${Colors.hoverBackgroundColor};
	}
`;
export const InlineDiv = styled.div`
    display:-webkit-inline-box;
    display:inline-flex;
    ${props => props.middle ? `
        display:flex;
        align-items:center;
    `: ""}
    ${props => props.fullWidth ? "width:100%;" : ""}
`;
export const VerticalMiddleContainer = (props)=>(
	<div style={{...props.style,position:"relative", display:"flex", alignItems:"center",height:"100%"}}>
		{props.children}
	</div>
);
export default withRouter(withThemeProvider(MainLayout));


// WEBPACK FOOTER //
// ./src/components/layout/Layout.js